import styled from "@emotion/styled";
import { media } from "../Window/themes";
const Header = {
    Wrapper: styled.header `
    font-weight: bold;
    text-transform: capitalize;
    color: ${({ theme }) => theme.color.headerTextColor};
    padding: 0.4rem;
    border-bottom: 0.1em solid ${({ theme }) => theme.color.backgroundAccent};
    margin-bottom: 0.5em;
    ${media.medium} {
      padding-left: 4rem;
    }
  `,
    Text: styled.p `
    white-space: nowrap;
    overflow: hidden;
    width: 78%;
    text-overflow: ellipsis;
    text-align: start;
    ${media.small} {
      width: 50%;
    }
  `,
    Container: styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: start;
    gap: 10px;
    min-height: 2.43rem;
    position: relative;
  `,
    NumberOfMembersIcon: styled.p `
    position: absolute;
    top: 25px;
    left: 3.5em;
    border-radius: 25%;
    background-color: ${({ theme }) => theme.color.badge};
    width: 20px;
    height: 20px;
    display: grid;
    place-items: center;
    font-size: 8px;
    font-weight: 700;
    color: ${({ theme }) => theme.color.headerTextColor};
  `,
};
export default Header;
//# sourceMappingURL=Header.styled.js.map